import { useUnit } from "effector-react"
import { t } from "i18next"
import { InlineMessage, Link, Typography } from "@callcenter/design-system"

import { emailConfirmationModel } from "../../models"

import mainStyles from "../../shared/styles.module.pcss"

export const EmailConfirmation = () => {
  const isCooldownActive = useUnit(emailConfirmationModel.$isActive)
  const hasError = useUnit(emailConfirmationModel.$hasError)
  const actions = useUnit({ sendRequested: emailConfirmationModel.trigger })

  return (
    <div className={mainStyles.accountInfoBlockWrapper}>
      <Typography.Body1>
        {t("userProfile_userProfileSidePanel_sectionHeading_emailConfirmationHeadLabel")}
      </Typography.Body1>
      {hasError && !isCooldownActive ? (
        <InlineMessage type="error">
          {t("userProfile_userProfileSidePanel_emailConfirmation_errorMessage")}
        </InlineMessage>
      ) : isCooldownActive ? (
        <InlineMessage type="info">{t("userProfile_userProfileSidePanel_emailConfirmation_sentMessage")}</InlineMessage>
      ) : (
        <InlineMessage type="warning">
          {t("userProfile_userProfileSidePanel_emailConfirmation_confirmMessage")}{" "}
          <Link kind="button" isDisabled={isCooldownActive} onClick={actions.sendRequested}>
            {t("userProfile_userProfileSidePanel_emailConfirmation_sendLink")}
          </Link>
        </InlineMessage>
      )}
    </div>
  )
}
